module.exports = __webpack_public_path__ + "media/images/activity-indicator-dark-5736a8c2e8eaf2326841964469d8504c.svg";